import { Component, inject, OnInit, ViewChild } from '@angular/core';

import { MatStepper } from '@angular/material/stepper';

import { tap } from 'rxjs';
import { BaseComponent } from 'src/app/core/components/base/base.component';
import { OnboardingStatus } from 'src/app/core/enum/OnboardingStatus';
import { AuthService } from 'src/app/core/services/auth';
import { OnboardingService } from 'src/app/core/services/onboarding';
import { SharedService } from 'src/app/core/services/shared';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss'],
})
export class OnboardingComponent extends BaseComponent implements OnInit {
  @ViewChild(MatStepper) matStepper!: MatStepper;

  authService = inject(AuthService);
  onboardingService = inject(OnboardingService);
  sharedService = inject(SharedService);
  onboardingStatus: OnboardingStatus | null = null;
  appName = this.sharedService.GetAppName();
  get selectedIndex(): number {
    if (this.onboardingStatus === OnboardingStatus.Finalizado) {
      return OnboardingStatus.Beneficios - 1;
    }

    return (this.onboardingStatus ?? 1) - 1;
  }

  ngOnInit(): void {
    this.setOnboardingStatus();
  }

  finalizeBeneficios(): void {
    if (this.onboardingStatus !== OnboardingStatus.Beneficios) {
      this.matStepper.next();
      return;
    }

    const loaderRef = this.loader.open('Salvando novo passo...');

    this.onboardingService
      .updateOnboarding(OnboardingStatus.Empresa)
      .pipe(
        this.takeUntilDestroyed(),
        tap(() =>
          this.authService.setOnboardingStatusToLocalStorage(
            OnboardingStatus.Empresa
          )
        )
      )
      .subscribe(() => {
        this.setCurrentStepAsCompleted();
        this.matStepper.next();
      })
      .add(() => loaderRef.close());
  }

  finalizeBeneficiarios(): void {
    if (this.onboardingStatus !== OnboardingStatus.Beneficiarios) {
      this.router.navigate(['inicio']);
      return;
    }

    const loaderRef = this.loader.open('Salvando novo passo...');
    this.onboardingService
      .updateOnboarding(OnboardingStatus.Finalizado)
      .pipe(
        this.takeUntilDestroyed(),
        tap(() =>
          this.authService.setOnboardingStatusToLocalStorage(
            OnboardingStatus.Finalizado
          )
        )
      )
      .subscribe(() => {
        this.notification.success('O Onboarding foi finalizado com sucesso!');
        this.router.navigate(['inicio']);
      })
      .add(() => loaderRef.close());
  }

  finalizeContrato(): void {
    if (
      [OnboardingStatus.Empresa, OnboardingStatus.Contrato].every(
        (s) => s !== this.onboardingStatus
      )
    ) {
      this.matStepper.next();
      return;
    }

    const loaderRef = this.loader.open('Salvando novo passo...');
    this.onboardingService
      .updateOnboarding(OnboardingStatus.Beneficiarios)
      .pipe(
        this.takeUntilDestroyed(),
        tap(() =>
          this.authService.setOnboardingStatusToLocalStorage(
            OnboardingStatus.Beneficiarios
          )
        )
      )
      .subscribe(() => {
        this.setCurrentStepAsCompleted();
        this.matStepper.next();
      })
      .add(() => loaderRef.close());
  }

  finalizeEmpresa(): void {
    if (this.onboardingStatus !== OnboardingStatus.Empresa) {
      this.matStepper.next();
      return;
    }

    const loaderRef = this.loader.open('Salvando novo passo...');
    this.onboardingService
      .updateOnboarding(OnboardingStatus.Contrato)
      .pipe(
        this.takeUntilDestroyed(),
        tap(() =>
          this.authService.setOnboardingStatusToLocalStorage(
            OnboardingStatus.Contrato
          )
        )
      )
      .subscribe(() => {
        this.setCurrentStepAsCompleted();
        this.matStepper.next();
      })
      .add(() => loaderRef.close());
  }

  private setOnboardingStatus() {
    this.authService.onboardingStatus$
      .pipe(this.takeUntilDestroyed())
      .subscribe((onboardingStatus) => {
        this.onboardingStatus = onboardingStatus;

        if (onboardingStatus === OnboardingStatus.NaoIniciado) {
          this.router.navigate(['onboarding', 'bem-vindo']);
        }
      });
  }

  private setCurrentStepAsCompleted(): void {
    const { selected } = this.matStepper;

    if (selected) {
      selected.completed = true;
    }
  }
}
